<template>
	<div>
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="schedulerCronIntervals" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Interval Type" id="filter-" size="sm" :model.sync="filter.intervalTypeId" @input="getSchedulerCronIntervals" @focus="getSchedulerCronIntervals" />
					<app-input-combobox-autocomplete :options="jobConfigurations" optionsLabel="jobName" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Job Type" id="filter-" size="sm" :model.sync="filter.jobTypeId" @input="getJobConfigurations" @focus="getJobConfigurations" />
					<app-input-textbox id="fieldset-recurring-job-id" label-cols-sm="4" label-cols-lg="3" label="Recurring Job Id" label-for="filter-recurring-job-id" size="sm" :model.sync="filter.recurringJobId" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getSchedulerConfigurations"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col>
				<b-button variant="warning" v-if="(userRole != null ? userRole.allowUpload : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowUpload : false)" class="float-right" :href="`files/SchedulerConfiguration/SchedulerConfiguration.xlsx`" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button>
			</b-col>
		 </b-row>
		<b-card class="mt-3">
		<b-row class="mb-3">
			<b-col>
				<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/schedulerconfiguration/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light"  :no-local-sorting="true" :items="schedulerConfigurations" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
			<template v-slot:head(actions)>
				<b-button-group class="float-right"  size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button>
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th stacked-heading="Interval Type">
					<v-select append-to-body label="name" :options="schedulerCronIntervals" :value="filter.intervalTypeId" :reduce="item => item.id" v-model="filter.intervalTypeId" :filterable="true" @input="getSchedulerConfigurationsWithoutLoading" @search="getSchedulerCronIntervals"></v-select>
				</b-th>
				<b-th stacked-heading="Interval Value">
					<b-form-input id="input-interval-value-table" @input="getSchedulerConfigurationsWithoutLoading" v-model="filter.intervalValue" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Interval Value 2">
					<b-form-input id="input-interval-value2-table" @input="getSchedulerConfigurationsWithoutLoading" v-model="filter.intervalValue2" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Interval Value 3">
					<b-form-input id="input-interval-value3-table" @input="getSchedulerConfigurationsWithoutLoading" v-model="filter.intervalValue3" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Cron Expression">
					<b-form-input id="input-cron-expression-table" @input="getSchedulerConfigurationsWithoutLoading" v-model="filter.cronExpression" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Job Type">
					<v-select append-to-body label="jobName" :options="jobConfigurations" :value="filter.jobTypeId" :reduce="item => item.id" v-model="filter.jobTypeId" :filterable="true" @input="getSchedulerConfigurationsWithoutLoading" @search="getJobConfigurations"></v-select>
				</b-th>
				<b-th stacked-heading="Recurring Job Id">
					<b-form-input id="input-recurring-job-id-table" @input="getSchedulerConfigurationsWithoutLoading" v-model="filter.recurringJobId" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Select All">
					<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(intervalType)="row">
				{{ row.item.intervalType != null ? row.item.intervalType.name : "" }}
			</template>
			<template v-slot:cell(jobType)="row">
				{{ row.item.jobType != null ? row.item.jobType.jobName : "" }}
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" :to="{path: '/schedulerconfiguration/edit/' + row.item.id }" variant ="success"  class="mr-2 btn-xs">
					<b-icon-pencil></b-icon-pencil>
				</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/schedulerconfiguration/detail/' + row.item.id }" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/schedulerconfiguration/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(schedulerConfigurationsPaging != null ? schedulerConfigurationsPaging.dataCount : 0)"
				:per-page="(schedulerConfigurationsPaging != null ? schedulerConfigurationsPaging.pageSize : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import SchedulerConfiguration from '@/models/SchedulerConfiguration/SchedulerConfiguration';
import SchedulerConfigurationList from '@/models/SchedulerConfiguration/SchedulerConfigurationList';
import SchedulerConfigurationFilter from '@/filters/SchedulerConfiguration/SchedulerConfigurationFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import SchedulerCronIntervalFilter from '@/filters/SchedulerCronInterval/SchedulerCronIntervalFilter';
import SchedulerCronInterval from '@/models/SchedulerCronInterval/SchedulerCronInterval';
import AppInputTextbox from '@/components/AppInputTextbox';
import JobConfigurationFilter from '@/filters/JobConfiguration/JobConfigurationFilter';
import JobConfiguration from '@/models/JobConfiguration/JobConfiguration';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {SchedulerConfiguration, SchedulerConfigurationList, SchedulerConfigurationFilter, AppInputTextarea,AppInputComboboxAutocomplete,AppInputTextbox,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				{"intervalType": {}, "class" : "th-interval-type", "label" : "Interval Type", key: 'intervalType', sortable: true}, 
				{"intervalValue": {}, "class" : "th-interval-value", "label" : "Interval Value", key: 'intervalValue', sortable: true}, 
				{"intervalValue2": {}, "class" : "th-interval-value2", "label" : "Interval Value 2", key: 'intervalValue2', sortable: true}, 
				{"intervalValue3": {}, "class" : "th-interval-value3", "label" : "Interval Value 3", key: 'intervalValue3', sortable: true}, 
				{"cronExpression": {}, "class" : "th-cron-expression", "label" : "Cron Expression", key: 'cronExpression', sortable: true}, 
				{"jobType": {}, "class" : "th-job-type", "label" : "Job Type", key: 'jobType', sortable: true}, 
				{"recurringJobId": {}, "class" : "th-recurring-job-id", "label" : "Recurring Job Id", key: 'recurringJobId', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			schedulerConfigurations: [],
			schedulerConfigurationsPaging: {},
			schedulerCronIntervals : [],
			jobConfigurations : [],
		}
	},
	methods : {
		getSchedulerConfigurations : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			SchedulerConfiguration.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.schedulerConfigurations = result.data
					this.schedulerConfigurationsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getSchedulerConfigurationsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			SchedulerConfiguration.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.schedulerConfigurations = result.data
					this.schedulerConfigurationsPaging = result
				}
			})
			.catch(error => {});
		},
		getSchedulerCronIntervals : async function(input) {
			let filter = new SchedulerCronIntervalFilter();
			if (input != undefined) {
				filter.name = input;
			}
			SchedulerCronInterval.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.schedulerCronIntervals = result.data
				}
			})
			.catch(error => {});
		},
		getJobConfigurations : async function(input) {
			let filter = new JobConfigurationFilter();
			if (input != undefined) {
				filter.jobName = input;
			}
			JobConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.jobConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new SchedulerConfigurationFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getSchedulerConfigurations();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				SchedulerConfiguration.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			SchedulerConfiguration.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			SchedulerConfiguration.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		deleteData(id) {
			SchedulerConfiguration.deleteData(this, id).then(result => {
				if (result)
				{
					this.getSchedulerConfigurations();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new SchedulerConfigurationFilter();
		this.getSchedulerCronIntervals()
		this.getJobConfigurations()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Scheduler Configuration"
		];
		this.getSchedulerConfigurations();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		sortDesc: {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		currentPage: {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				SchedulerConfiguration.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "schedulerconfigurationindex") {
					this.getSchedulerConfigurationsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "scheduler_configuration").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
